import { useMedia } from 'react-use'

export type DeviceType = 'mobile' | 'tablet' | 'desktop'

export default function useDeviceType(): DeviceType {
  const isDesktop = useMedia('(min-width: 1024px)', false)
  const isTablet = useMedia('(min-width: 768px)', false)

  if (isDesktop) return 'desktop'
  if (isTablet) return 'tablet'
  return 'mobile'
}
